import React from "react";
import { FixedSizeList as List } from "react-window";

/**
 * Virtualize menu list
 * @param {*} param0
 * @returns
 */
const MenuList = ({ options, children, maxHeight, getValue }) => {
  const height = 35; // adjust as needed
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;

  return (
    <List height={maxHeight} itemCount={children.length} itemSize={height} initialScrollOffset={initialOffset}>
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

export default MenuList;
